export const IDS_TRAZABILITY_FLOW_ADVALTECH_PROD = [77, 201];
export const IDS_TRAZABILITY_FLOW_ADVALTECH_TEST = [4];
export const IDS_TRAZABILITY_FLOW_ADVALTECH_DEV = [4];
export const IDS_SCANER_TIME = [160];
export const IDS_COMPANY_CREATE_TRAZABILITY_AND_PRODUCTIVITY = [
  154, 179, 160, 152
];

export const IDS_TRAZABILITY_FLOW_BAFAR_PROD = [164];
export const IDS_TRAZABILITY_FLOW_BAFAR_TEST = [3, 152];
export const IDS_TRAZABILITY_FLOW_BAFAR_DEV = [3, 1, 152, 164];

export const IDS_SHOW_HELP_VIEWS_DEV = [152, 164, 160, 5];
export const IDS_SHOW_HELP_VIEWS_PROD = [160, 152];

export const IDS_COMPANY_BY_RULES_SCAN = [5, 247];

export const IDS_WORKSTATIONS_IKANO_VALIDATION = [
  1789, 3043 /*workstation test*/, 2111, 2113, 3279, 3278
];

// company develop ID = 152
